import { io } from "socket.io-client";

const URLAttendance = `${process.env.VUE_APP_WS_TC_URL}/attendance`;
const socket = io(URLAttendance, {
  withCredentials: true, autoConnect: false, transports: ['websocket'], multiplex: false, forceNew: true, upgrade: false, reconnection: true, timeout: 80000, reconnectionDelay: 1000,
});

export default socket;
